import { render, staticRenderFns } from "./chufangDetail.vue?vue&type=template&id=38204699&scoped=true&"
import script from "./chufangDetail.vue?vue&type=script&lang=js&"
export * from "./chufangDetail.vue?vue&type=script&lang=js&"
import style0 from "./chufangDetail.vue?vue&type=style&index=0&id=38204699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38204699",
  null
  
)

export default component.exports